import React from 'react'
import { Check, PlayCircle } from 'react-feather'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Col, FormGroup, Label, Row } from 'reactstrap'
import { WIZARDS } from '.'
import { changeOpenWizard, completeWizard } from '../../redux/actions'
import { CardHorizontal, CARD_ACTION_COLORS } from '../Cards'
import { Wizard } from './Wizard'

export const PaymentMethodsWizardCard = ({ onClick, completed = false, CTA = false }) => {
    return (
        <CardHorizontal color={!!completed ? CARD_ACTION_COLORS.SUCCESS : CARD_ACTION_COLORS.DEFAULT} onClick={onClick}>
            <FormGroup className="position-relative">
                <Label>Configurar um meio de recebimento</Label>
                <p>Cadastre um para que possa começar a receber pagamentos online nas reservas.</p>
                {!!completed && <Check style={{ position: 'absolute', top: 0, right: 0 }} color={CARD_ACTION_COLORS.SUCCESS} />}
            </FormGroup>
            <FormGroup>
                <Button color="primary" outline={!CTA}><PlayCircle /> Iniciar</Button>
            </FormGroup>
        </CardHorizontal>
    )
}

export const PaymentMethodWizard = ({}) => { 
    const { openWizard } = useSelector(state => state.app)
    const dispatch = useDispatch()

    return (
        <Wizard title="Configurar um meio de recebimento" open={openWizard === WIZARDS.PAYMENT_METHODS} onClose={() => dispatch(changeOpenWizard())}>
            <Row>
                <Col>
                    <p><strong>1.</strong> No menu, clique na seta ao lado do nome da empresa e clique em MEU NEGÓCIO.</p>
                    <p> <img src='https://adrenalyze-app.s3-sa-east-1.amazonaws.com/offstation/imgs/Screenshot_32.jpg' alt='Onde clicar.' style={{ border: '1px solid #1855B7', margin: 'auto', display: 'block', height: 'auto', width: '100%' }} /> </p>
                    <p><strong>2.</strong> Confirme sua senha.</p>
                    <p> <img src='https://adrenalyze-app.s3-sa-east-1.amazonaws.com/offstation/imgs/Screenshot_33.jpg' alt='Onde clicar.' style={{ border: '1px solid #1855B7', margin: 'auto', display: 'block', height: 'auto', width: '100%' }} /> </p>
                    <p><strong>3.</strong> Selecione a aba RECEBIMENTOS.</p>
                    <p> <img src='https://adrenalyze-app.s3-sa-east-1.amazonaws.com/offstation/imgs/Screenshot_37.jpg' alt='Onde clicar.' style={{ border: '1px solid #1855B7', margin: 'auto', display: 'block', height: 'auto', width: '100%' }} /> </p>
                    <p><strong>4.</strong> Conforme preferir, escolha uma das opções de integrações disponibilizadas. Também é possível integrar mais de um meio, basta refazer os próximos passos para cada um dos gateways de pagamento que escolher.</p>
                    <p> <img src='https://adrenalyze-app.s3-sa-east-1.amazonaws.com/offstation/imgs/Screenshot_38.jpg' alt='Onde clicar.' style={{ border: '1px solid #1855B7', margin: 'auto', display: 'block', height: 'auto', width: '100%' }} /> </p>
                    <p><strong>5.</strong> Ao entrar em qualquer um deles, basta seguir os comandos indicados. Eventualmente você vai encontrar links para páginas de ajuda do próprio gateway, que irá te auxiliar a executar os comando dentro da plataforma. </p>
                    <p> <img src='https://adrenalyze-app.s3-sa-east-1.amazonaws.com/offstation/imgs/Screenshot_39.jpg' alt='Onde clicar.' style={{ border: '1px solid #1855B7', margin: 'auto', display: 'block', height: 'auto', width: '100%' }} /> </p>
                    <p><strong>6.</strong> Clique em SALVAR para receber a mensagem de confirmação.</p>
                    <p> <img src='https://adrenalyze-app.s3-sa-east-1.amazonaws.com/offstation/imgs/Screenshot_36.jpg' alt='Onde clicar.' style={{ border: '1px solid #1855B7', margin: 'auto', display: 'block', height: 'auto', width: '100%' }} /> </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button color="primary" onClick={() => dispatch(completeWizard(WIZARDS.PAYMENT_METHODS))} outline><Check /> Concluir</Button>
                </Col>
            </Row>
        </Wizard>
    )
}
